import * as React from 'react'
import * as css from './ProjectsList.module.css'
import { Link } from 'gatsby'
import MarkerIcon from 'components/map/MarkerIcon'
import { HiOfficeBuilding } from 'react-icons/hi'
import { FaMapMarkerAlt } from 'react-icons/fa'
import { MdLocalGasStation } from 'react-icons/md'
import { ImNewspaper } from 'react-icons/im'
import clsx from 'clsx'

/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */

export default function ProjectsList({ projects }) {
	return (
		<section className="flex flex-col space-y-3 bg-white/5 p-4">
			<div className="technical text-right text-sm font-bold">
				{projects.length} Projects
			</div>

			<dl className="projects-list flex grow flex-col overflow-y-auto border-t border-white/60 pr-4 <md:max-h-[25em]">
				{projects?.map((project) => (
					<label
						htmlFor={`input-${project._id}`}
						className={clsx(
							css.project,
							'anim-fadein group block cursor-pointer space-y-3 border-b border-white/60 py-3',
						)}
						onClick={() => {
							if (typeof document === 'undefined') return
							document.querySelector(`#marker-${project._id}`).click()
						}}
						key={`${project._id}`}
					>
						<dt className="grid grid-cols-[1fr,auto] items-center gap-x-4 text-lg font-bold leading-tight group-hover:underline">
							{project.description}

							<MarkerIcon className="text-sm" type={project.type?.[0]} />
						</dt>

						<div className="hide-when-ob grid space-y-2">
							<dd className="with-icon justify-start">
								<HiOfficeBuilding /> {project.company}
							</dd>

							<dd className="with-icon justify-start">
								<FaMapMarkerAlt /> {project.city}
							</dd>

							{project.isHydrogenFuel && (
								<dd className="with-icon justify-start">
									<MdLocalGasStation /> Hydrogen Fuel
								</dd>
							)}

							{project.caseStudy && (
								<dd>
									<Link
										className="with-icon underline hover:decoration-2"
										to={`/${project.caseStudy.seo.slug.current}`}
									>
										<ImNewspaper />
										{project.caseStudy.title}
									</Link>
								</dd>
							)}
						</div>
					</label>
				))}
			</dl>
		</section>
	)
}
